import React from "react";
import {
  Timeline,
  TextMsg,
  DocMsg,
  BotChat,
  AudioMsg,
  VideoMsg,
  ImageMsg,
} from "../MessageTypes-component/MsgTypes";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { connect } from "react-redux";
import {
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
} from "../../../../Redux/Actions/actions";

const mapStateToProps = (state) => {
  return {
    externalChatData: state.data.externalChatData,
    chatspinner: state.data.chatspinner,
    loadmoreSpinner: state.data.loadmoreSpinner,
    customerTyping: state.data.customerTyping,
    externalChatData: state.contactListData.externalChatData,
    customerTypingId: state.contactListData.customerTypingId,
    userlistshow: state.data.userlistshow,
    message: state.chatReducer.message,
  };
};

const ConversationBodyExternal = (props) => {
  let selectedChat = JSON.parse(localStorage.getItem("client"))
    ? JSON.parse(localStorage.getItem("client"))
    : {};
  const { message, menu } = props;

  return (
    <>
      {props.chatspinner && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {!props.chatspinner && (
        <>
          {message.length > 0 ? (
            <>
              {message.map((el, index) => {
                switch (el.msg_sent_type) {
                  case "NOTIFICATIONS":
                    return <Timeline el={el} key={index} />;
                  case "jpeg":
                  case "png":
                  case "IMAGE":
                  case "APPLICATION":
                    return <ImageMsg el={el} menu={menu} key={index} />;
                  case "docx":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"docx"}
                        size={"200px"}
                      />
                    );
                  case "pdf":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"pdf"}
                        size={"200px"}
                      />
                    );
                  case "vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"xlsx"}
                        size={"200px"}
                      />
                    );
                  case "plain":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"plain"}
                        size={"200px"}
                      />
                    );

                  case "vnd.openxmlformats-officedocument.wordprocessingml.document":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"docx"}
                        size={"200px"}
                      />
                    );

                  case "msword":
                    return (
                      <DocMsg
                        el={el}
                        menu={menu}
                        key={index}
                        type={"docx"}
                        size={"200px"}
                      />
                    );
                  case "AUDIO":
                  case "wav":
                    return <AudioMsg el={el} menu={menu} key={index} />;
                  case "mp4":
                  case "VIDEO":
                  case "webm":
                    return <VideoMsg el={el} menu={menu} key={index} />;
                  default:
                    return (
                      <TextMsg el={el} menu={menu} key={index} size={"300px"} />
                    );
                }
              })}
              {selectedChat.id == props.customerTypingId &&
                props.customerTyping && <BotChat />}
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
};

export default connect(mapStateToProps, {
  setExternalChatData,
  updateNotification,
  setChatSpinner,
  setMsgTone,
  setMsgTone2,
})(ConversationBodyExternal);
